import { PortfolioDetail, EVENTS_CFG } from "@/components/Portfolio";
export default function EventDetail() {
  return <PortfolioDetail cfg={EVENTS_CFG} />;
}
